import { map } from 'ramda';
import { all, fork } from 'redux-saga/effects';
import appSagas from '../features/app/app-sagas';

export default function* rootSaga() {
  yield all(map<any, any>(fork, [...appSagas]));
}
